enum FilemanagerActions {
  FETCH_LIST = "FilemanagerFetchList",
  GET_ITEM = "FilemanagerGetItem",
  UPDATE_ITEM = "FilemanagerUpdateItem",
  REPLACE_ITEM = "FilemanagerReplaceItem",
  DELETE_ITEM = "FilemanagerDeleteItem",
  FETCH_USAGE = "FilemanagerFetchUsage",
  REFRESH_LIST = "FilemanagerRefreshList",
  UPLOAD_DATA = "FilemanagerCreateItem",
  BATCH_UPLOAD = "FilemanagerBatchUpload",
}

enum FilemanagerMutation {
  SET_RENDER_UPDATE = "FilemanagerListRenderNeeded",
  SET_LIST_RESULT = "FilemanagerListResult",
}

export { FilemanagerActions, FilemanagerMutation };
